export default __webpack_public_path__ + "static/assets/847dd8f8c24123a89639cbd55fb50023.png";